import {Flex, MyCampo} from "../ui";
import { multimediaEpaycoUrl } from "../../utils/multimedia";
import {Btn} from "./../UI-Components/Btn";
import React, {Fragment} from "react";
import MyRadio from "../Helpers/Radios";
import {total, Check, Datos} from "./helpers_styles";

export const FooterL = (props) => {
    return (
        <Flex className={"py-2 px-lg-4"}>
            <div className="col-12 col-md-7 col-xl-8 cg px-0">
                <div className="col-12 py-3">
                    <p className={"mb-0"} css={total}>Total a pagar :
                        ${parseFloat(props.total).toLocaleString('en-US', {minimumFractionDigits: 0})} {props.moneda}</p>
                </div>
            </div>
            <div className="col-12 col-md-5 col-xl-4 px-0">
                <div className="col-12">
                    {props.disableButton &&
                        <Btn
                            loading={props.loading}
                            disabled={props.loading}
                            onClick={() => props.pagarFacturas()}
                        >
                            Pagar seleccionados
                        </Btn>
                    }
                </div>
            </div>
        </Flex>
    )
};

export const AbonoMultiplesValores = (props) => {

    return props.facturas.map((fac, key) => {
        return (
            <Flex className={"wc bgb ro mb-3"} alg="stretch" key={"factura" + key}>

                <Flex className="col-2 col-md-1 px-0 main-check" direction={"colunm"}>
                    <Mycheck
                        active={props.checks.length > 0 ? props.checks[key] : false}
                        clickCheck={props.clickCheck.bind(this)} value={key}
                    />
                </Flex>

                <Flex className="px-0" alg={"stretch"} jc={"flex-start"} elastic="1 0 115px">
                    {fac.map((it, key2) => {
                        if (it.entidad === 'facturaId') {
                            return (
                                <Flex
                                    direction={"column"}
                                    alg={"flex-start"}
                                    key={"it" + key2}
                                    className={`py-2 dato f02 px-3`}
                                    elastic="1 0 115px"
                                >
                                    <b>{it.titulo}</b>
                                    <p className={"mb-0 cg "}>
                                        {it.valor}
                                    </p>
                                </Flex>
                            )
                        }
                    })}
                    <Flex className={`col-12 
                             col-md-8
                            dato`}
                          alg={"flex-end"}
                    >
                        <div className={`col-12 px-0`}>
                            <Flex className="wc px-3 pb-2" alg={"flex-end"}>
                                <Flex className={"text-center"} elastic={"1 0 100px"}>
                                    <div className="text-center p-0">
                                        <MyRadio color="primary"
                                                 name={'MyRadio'}
                                                 onChange={props.clickCheckOtroValor.bind(this)}
                                                 checked={props.checksOtroValor.length > 0 ? props.checksOtroValor[key] : false}
                                                 value={key}
                                        />
                                    </div>
                                    <div className={"wc text-center"}>
                                        <b>Otro valor</b>
                                    </div>
                                    <Flex elastic={"1 0 150px"}>
                                        <MyCampo
                                            type="mount"
                                            placeholder={"Otro valor"}
                                            value={props.valuesOtroValor[key]}
                                            name={key}
                                            onChangeValor={props.onChangeOtroValor.bind(this)}
                                            obligatory={false}
                                            disabled={!props.checksOtroValor[key]}
                                            bordeAzul
                                        />
                                    </Flex>
                                </Flex>
                                <Flex direction={"colunm"}
                                      onClick={() => props.salirCambiarPantalla()}
                                      elastic={"0 0 80px"}
                                      className={"pl-3 pb-2"}
                                >
                                    <i
                                        className={`fa fa-arrow-left fa-lg ml-1 icon-back-arrow`}
                                    />
                                    <p className={"ct mb-0 pl-2 back-text-dynamic"}>Atrás</p>
                                </Flex>
                            </Flex>
                        </div>

                    </Flex>
                </Flex>

            </Flex>
        )
    })
};

export const Mycheck = ({active, clickCheck, value, all = false, abonar = false, white}) => {

    return (
        <Check active={active} white={white} abonar={abonar}>
            <div className={"check"}>
                <img src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/check.png")}
                     alt=""

                />
            </div>
            <input type="checkbox" onClick={() => clickCheck(value, all)}/>
        </Check>
    )
};

export const Factura = (data) => {

    function opcionFacturas(props) {

        let opcionRecado    =  props.opcionesRecaudo !== "" && props.opcionesRecaudo;
        let agruparFacturas =  opcionRecado && props.opcionesRecaudo.agruparFacturas.activo;
        let modificarValor  =  opcionRecado && props.opcionesRecaudo.modificarValorPagar.activo;

        if ( agruparFacturas || modificarValor ) {
            if (agruparFacturas && modificarValor) {
                if ((props.opcionesRecadudo.multiplesValoresPago.activo || props.opcionesRecadudo.fechasVencimiento.activo)) {
                    return (
                        <Fragment>
                            {props.facturas.map((fac, key) => {
                                return (
                                    <Flex className={"wc p-1"} alg="stretch" key={"factura" + key}>
                                        <Flex
                                            className={"p-1"}
                                            elastic={`
                                              1 0 ${
                                                props.opcionesRecadudo.multiplesValoresPago.opcion === "1" ? "600px" :
                                                    props.opcionesRecadudo.multiplesValoresPago.opcion === "2" ? "700px" :
                                                        props.opcionesRecadudo.multiplesValoresPago.opcion === "3" ? "800px" : "600px"
                                            }`}
                                        >
                                            <Datos elastic={"1 0 100%"}>
                                                <Flex elastic={"0 0 30px"} className="main-check" direction={"colunm"}>
                                                    <Mycheck
                                                        active={props.checks.length > 0 ? props.checks[key] : false}
                                                        clickCheck={props.clickCheck.bind(this)} value={key}
                                                    />
                                                </Flex>
                                                <Flex elastic={"1 0 50%"} alg={"stretch"} className={"px-1"}>

                                                    {/*////// Numero de la factura  //////*/}
                                                    {fac.map((it, key2) => {
                                                        if (it.entidad === "facturaId") {
                                                            return (
                                                                <Flex
                                                                    key={"it" + key2}
                                                                    className={
                                                                        props.opcionesRecaudo != "" &&
                                                                        props.opcionesRecaudo &&
                                                                        (props.opcionesRecadudo.multiplesValoresPago.activo ||
                                                                            props.opcionesRecadudo.fechasVencimiento.activo) ?
                                                                            ` px-0  dato` : ` px-0  dato hc`
                                                                    }
                                                                    elastic={"1 0 100%"}
                                                                >
                                                                    <Flex
                                                                        direction={"colunm"}
                                                                        elastic={"0 0 30px"}
                                                                        className={"mr-2"}
                                                                    >
                                                                        <i
                                                                            onClick={() => props.showModal(key)}
                                                                            className={`fa fa-info-circle fa-lg icon-info-circle`}
                                                                        />
                                                                    </Flex>

                                                                    <Flex
                                                                        className={"text-left"}
                                                                        jc={"flex-start"}
                                                                        elastic={"1 0 100px"}
                                                                    >
                                                                        {props.tituloFactura === it.titulo &&
                                                                        <MyRadio color="primary"
                                                                                 name={'MyRadio'}
                                                                                 onChange={props.clickCheck.bind(this)}
                                                                                 checked={props.checks.length > 0 ? props.checks[key] : false}
                                                                                 value={key}
                                                                        />
                                                                        }
                                                                        {/* <Mycheck
                                                                            abonar={props.abonarFactura}
                                                                            active={props.checks.length > 0 ? props.checks[key] : false}
                                                                            clickCheck={props.clickCheck.bind(this)}
                                                                            value={key}/> */}

                                                                        <b className="fs-13">{it.titulo}</b>
                                                                        <p className={"ml-2 mb-0 cg description"}>{it.valor}</p>
                                                                    </Flex>

                                                                </Flex>
                                                            )
                                                        }
                                                    })}
                                                    {/*////// Numero de la factura  //////*/}

                                                    <Flex
                                                        elastic={`
                                                            1 0 ${
                                                            props.opcionesRecadudo.multiplesValoresPago.opcion === "1" ? "140px" :
                                                                props.opcionesRecadudo.multiplesValoresPago.opcion === "2" ? "240px" :
                                                                    props.opcionesRecadudo.multiplesValoresPago.opcion === "3" ? "355px" : "450px"
                                                        }`}
                                                    >
                                                        {fac.map((it, key2) => {
                                                            if (
                                                                it.entidad === 'total' ||
                                                                it.entidad === 'segundoTotal' ||
                                                                it.entidad === 'tercerTotal') {

                                                                return (
                                                                    <Flex
                                                                        key={"it" + key2}
                                                                        elastic={"1 0 150px"}
                                                                        className={"p-1"}
                                                                    >
                                                                        {it.entidad === 'total' &&
                                                                        <Flex
                                                                            elastic={"0 0 20px"}
                                                                        >
                                                                            <MyRadio
                                                                                color="primary"
                                                                                name={'MyRadio'}
                                                                                onChange={props.clickCheckValor1.bind(this)}
                                                                                checked={props[`checksValor1`].length > 0 ? props[`checksValor1`][key] : false}
                                                                                value={key}
                                                                            />
                                                                        </Flex>
                                                                        }
                                                                        {it.entidad === 'segundoTotal' &&
                                                                        <Flex
                                                                            elastic={"0 0 20px"}
                                                                        >
                                                                            <MyRadio color="primary"
                                                                                     name={'MyRadio'}
                                                                                     onChange={props.clickCheckValor2.bind(this)}
                                                                                     checked={props[`checksValor2`].length > 0 ? props[`checksValor2`][key] : false}
                                                                                     value={key}
                                                                            />
                                                                        </Flex>
                                                                        }

                                                                        {it.entidad === 'tercerTotal' &&
                                                                        <Flex elastic={"0 0 20px"}>
                                                                            <MyRadio
                                                                                color="primary"
                                                                                name={'MyRadio'}
                                                                                onChange={props.clickCheckValor3.bind(this)}
                                                                                checked={props[`checksValor3`].length > 0 ? props[`checksValor3`][key] : false}
                                                                                value={key}
                                                                            />
                                                                            {/* <Mycheck
                                                                        abonar={props.abonarFactura}
                                                                        active={props[`checksValor3`].length > 0 ? props[`checksValor3`][key] : false}
                                                                        clickCheck={props.clickCheckValor3.bind(this)}
                                                                        value={key}
                                                                    /> */}
                                                                        </Flex>
                                                                        }

                                                                        <Flex
                                                                            jc={"flex-start"}
                                                                            elastic={"1 0 80%"}
                                                                            className={"p-1"}
                                                                        >
                                                                            <div className="wc text-left">
                                                                                <b
                                                                                    className={"d-block title-small-12"}
                                                                                >
                                                                                    {it.titulo}
                                                                                </b>
                                                                            </div>
                                                                            <p className={"mb-0 cg description "}>
                                                                                {it.valor}
                                                                                {/*$999.000.000.00 COP*/}
                                                                            </p>
                                                                        </Flex>
                                                                    </Flex>
                                                                )
                                                            }
                                                        })}
                                                    </Flex>

                                                    {/*{//////// Custom value //////}*/}
                                                    {props.opcionesRecaudo.modificarValorPagar.activo &&
                                                    <Flex
                                                        className={` text-center dato
                                                    ${props.opcionesRecadudo.multiplesValoresPago.opcion !== "3" ? "" : "lineUp"}`}
                                                        elastic={"1 0 150px"}
                                                    >

                                                        <Flex jc={"flex-start"} elastic={"0 0 150px"}>
                                                            <MyRadio
                                                                color="primary"
                                                                name={props.opcionesRecaudo.modificarValorPagar.activo}
                                                                onChange={props.clickCheckOtroValor.bind(this)}
                                                                checked={props.checksOtroValor.length > 0 ? props.checksOtroValor[key] : false}
                                                                value={key}
                                                            />
                                                            {/* <Mycheck
                                                        abonar={props.abonarFactura}
                                                        active={props.checksOtroValor.length > 0 ? props.checksOtroValor[key] : false}
                                                        clickCheck={props.clickCheckOtroValor.bind(this)}
                                                        value={key}/> */}
                                                            <b
                                                                className={"d-block ml-2 fs-13"}
                                                            >
                                                                Otro valor
                                                            </b>
                                                        </Flex>
                                                        <MyCampo
                                                            type="mount"
                                                            placeholder={"Otro valor"}
                                                            value={props.valuesOtroValor[key]}
                                                            name={key}
                                                            onChangeValor={props.onChangeOtroValor.bind(this)}
                                                            obligatory={false}
                                                            // configuracionCampos={conf.fieldTypes}
                                                            disabled={!props.checksOtroValor[key]}
                                                            // error={error}
                                                            bordeAzul={true}
                                                            flex={"1 0 100%"}
                                                        />
                                                    </Flex>}
                                                    {/*{//////// Custom value //////}*/}
                                                </Flex>
                                            </Datos>
                                        </Flex>

                                        {/*///   Buttón pagar  ////*/}
                                        <Flex
                                            elastic={"1 0 60px"}
                                            className={"p-1"}
                                        >
                                            <Btn
                                                onClick={() => props.pagar(key)}
                                                brdr={"6px"}
                                                hg={"100%"}
                                                className={"hc"}
                                                classNameBtn={"p-2"}
                                            >
                                                PAGAR
                                            </Btn>
                                        </Flex>
                                    </Flex>
                                )
                            })}
                        </Fragment>
                    )
                }
                else {
                    return (
                        <div className={"wc "}>
                            {props.facturas.map((fac, key) => {
                                return (
                                    <Flex className={"px-lg-3 mb-3"} alg="stretch" key={"factura" + key}>
                                        <Flex className={"col-12 col-md-9 col-lg-10 py-md-1"} css={Datos}>
                                            <Flex className="col-2 col-md-1" direction={"colunm"}>
                                                <Mycheck
                                                    active={props.checks.length > 0 ? props.checks[key] : false}
                                                    clickCheck={props.clickCheck.bind(this)} value={key}
                                                />
                                            </Flex>
                                            <Flex className="col-10 col-md-11 px-0">
                                                {fac.map((it, key2) => {
                                                    if (key2 === 0) {
                                                        return (
                                                            <div
                                                                key={"it" + key2}
                                                                className={
                                                                    (   props.opcionesRecadudo.multiplesValoresPago.activo ||
                                                                        props.opcionesRecadudo.fechasVencimiento.activo) ?
                                                                        `col-12 col-md-4 py-2 dato height-100-display-flex` :
                                                                        `col-12 col-md-6 py-2 dato height-100-display-flex`
                                                                }
                                                            >
                                                                <Flex direction={"colunm"}>
                                                                    <i
                                                                        onClick={() => props.showModal(key)}
                                                                        className={`fa fa-info-circle fa-lg icon-info-circle`}
                                                                    />
                                                                </Flex>

                                                                {props.tituloFactura === it.titulo &&
                                                                <MyRadio color="primary"
                                                                         name={'MyRadio'}
                                                                         onChange={props.clickCheck.bind(this)}
                                                                         checked={props.checks.length > 0 ? props.checks[key] : false}
                                                                         value={key}
                                                                />}
                                                                <b>{it.titulo}</b>
                                                                <p className={"mb-0 cg description "}>{it.valor}</p>
                                                            </div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div
                                                                key={"it" + key2}
                                                                className={`col-12 col-md-4 py-2 dato height-100`}
                                                            >
                                                                {props.tituloFactura === it.titulo &&
                                                                <div>
                                                                    <MyRadio color="primary"
                                                                             name={'MyRadio'}
                                                                             onChange={it.opcion === 1 ? props.clickCheckValor1.bind(this) : ""}
                                                                             checked={props[`checksValor1`].length > 0 ? props[`checksValor1`][key] : false}
                                                                             value={key}
                                                                    />
                                                                </div>
                                                                }
                                                                <b>{it.titulo}</b>
                                                                <p className={"mb-0 cg description "}>
                                                                    {it.valor}
                                                                </p>
                                                            </div>
                                                        )
                                                    }
                                                })
                                                }
                                                {props.opcionesRecaudo.modificarValorPagar.activo &&
                                                <div
                                                    className={`col-12 col-md-4 py-2 py-md-0 dato`}
                                                >
                                                    <div>
                                                        <MyRadio color="primary"
                                                                 name={'MyRadio'}
                                                                 onChange={props.clickCheckOtroValor.bind(this)}
                                                                 checked={props.checksOtroValor.length > 0 ? props.checksOtroValor[key] : false}
                                                                 value={key}
                                                        />
                                                    </div>
                                                    <b>Otro valor</b>
                                                    <MyCampo
                                                        type="mount"
                                                        placeholder={"Otro valor"}
                                                        value={props.valuesOtroValor[key]}
                                                        name={key}
                                                        onChangeValor={props.onChangeOtroValor.bind(this)}
                                                        obligatory={false}
                                                    />

                                                </div>}
                                            </Flex>
                                        </Flex>
                                        <div
                                            className="col-12 col-lg-2 pt-2 pt-md-0 px-0 pl-md-3 col-md-3 ml-md-auto mr-md-0">
                                            <Btn
                                                onClick={() => props.pagar(key)}
                                                brdr={"12px"}
                                                hg={"100%"}
                                                className={" py-lg-0 hc"}
                                            >
                                                PAGAR
                                            </Btn>
                                        </div>
                                    </Flex>
                                )
                            })}
                        </div>
                    )
                }

            }
            else if (agruparFacturas&& !props.abonarFactura) {
                return (
                    <div className={"wc"}>
                        {
                            props.facturas.map((fac, key) => {
                                return <Flex className={"px-lg-3 mb-3"} alg="stretch" key={"factura" + key}>
                                    <Flex className={"col-12 col-md-9 col-lg-10 py-md-1"} css={Datos}>
                                        <Flex className="col-2 col-md-1" direction={"colunm"}>
                                            <Mycheck
                                                active={props.checks.length > 0 ? props.checks[key] : false}
                                                clickCheck={props.clickCheck.bind(this)} value={key}/>
                                        </Flex>
                                        <Flex className="col-8 col-md-10 ">
                                            <Flex className="col-12">
                                                {fac.map((it, key2) => {
                                                    return (
                                                        <div key={"it" + key2}
                                                             className={`col-12 col-md-${fac.length === 2 ? '6' : '4'} py-2 dato`}>
                                                            <b>{it.titulo}</b>
                                                            <p className={"mb-0 cg description "}>
                                                                {it.valor}
                                                            </p>
                                                        </div>
                                                    )
                                                })}
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                    <div
                                        className="col-12 col-lg-2 pt-2 pt-md-0 px-0 pl-md-3 col-md-3 ml-md-auto mr-md-0 ">
                                        <Btn
                                            onClick={() => props.pagar(key)}
                                            brdr={"12px"}
                                            hg={"100%"}
                                            className={"py-2 py-lg-0 hc"}>
                                            PAGAR</Btn>
                                    </div>
                                </Flex>
                            })
                        }
                    </div>
                )
            } else if (!agruparFacturas && props.abonarFactura) {
                return (
                    <div className={"wc"}>
                        {
                            props.facturas.map((fac, key) => {
                                return (<Flex className={"px-lg-3 mb-3"} alg="stretch" key={"factura" + key}>
                                    <Flex className={"col-12 col-md-9 col-lg-10 py-md-1"} css={Datos}>
                                        <Flex className="col-12">
                                            {fac.map((it, key2) => {
                                                return (

                                                    <div
                                                        key={"it" + key2}
                                                        className={`col-12 col-md-${fac.length === 2 ? '6' : '4'} py-2 dato`}
                                                    >
                                                        {props.tituloFactura === it.titulo &&
                                                        <div>
                                                            <Mycheck
                                                                abonar={props.abonarFactura}
                                                                active={props.checks.length > 0 ? props.checks[key] : false}
                                                                clickCheck={props.clickCheck.bind(this)} value={key}/>
                                                        </div>
                                                        }
                                                        <b>{it.titulo}</b>
                                                        <p className={"mb-0 cg description "}>
                                                            {it.valor}
                                                        </p>
                                                    </div>
                                                )
                                            })}
                                        </Flex>
                                    </Flex>
                                    <div
                                        className="col-12 col-lg-2 pt-2 pt-md-0 px-0 pl-md-3 col-md-3 ml-md-auto mr-md-0 ">
                                        <Btn
                                            onClick={() => props.pagar(key)}
                                            brdr={"12px"}
                                            hg={"100%"}
                                            className={"py-2 py-lg-0 hc"}
                                        > PAGAR
                                            FACTURA </Btn>
                                    </div>
                                </Flex>)
                            })
                        }
                    </div>
                )
            }
        } else {
            return (
                props.facturas.map((fac, key) => {
                    return (
                        <Flex className={"py-2"} alg="stretch" key={"factura" + key}>
                            <Flex className={"col-12 col-md-9 col-lg-10  px-1 bgg"} css={Datos}>
                                <Flex className="wc py-2 border-radius-white">
                                    {fac.map((it, key2) => {
                                        return (
                                            <div key={"it" + key2}
                                                 className={`col-12 col-md-${fac.length === 2 ? '6' : '4'} dato`}>
                                                <b>{it.titulo}</b>
                                                <p className={"mb-0 cg description "}>
                                                    {it.valor}
                                                </p>
                                            </div>
                                        )
                                    })}
                                </Flex>
                            </Flex>
                            <div className="col-12 col-lg-2 col-md-3 px-1">
                                <Btn
                                    onClick={() => props.pagar(key)}
                                    brdr={"10px"}
                                    className={"py-lg-0 hc"}> PAGAR
                                </Btn>
                            </div>
                        </Flex>
                    )
                })
            )
        }
    }

    return opcionFacturas(data)
};
